module.exports = __webpack_public_path__ + "img/2.1aaa79f4.jpg";